import { UserManager } from "oidc-client-ts";
import { oidcConfig } from "./oidcConfig";

/**
 * One UserManager instance shared by AuthProvider, CallbackPage, and the
 * RTK Query base query (store/api/apiSlice.ts) — the latter needs to read
 * the current access token outside React's component tree, so it can't
 * go through the AuthProvider context.
 */
export const userManager = new UserManager(oidcConfig);
